interface IColor {
  base: string;
  'dark-60'?: string;
  'dark-80'?: string;
  'light-20'?: string;
  'light-30'?: string;
  'light-40'?: string;
  'light-50'?: string;
}
interface IColorGradual {
  '04'?: string;
  10?: string;
  20?: string;
  40?: string;
  60?: string;
  100?: string;
  120?: string;
  140?: string;
  180?: string;
}
export interface IColors {
  black: string;
  correct: IColor;
  incorrect: IColor;
  neutral: IColor;
  primary: IColor;
  secondary: IColor;
  gmBlue: IColor;
  eurekaMath: IColor;
  eurekaMathBands: IColor;
  eurekaMathStates: IColor;
  ww: IColor;
  wwStates: IColor;
  wwBands: IColor;
  phdScience: IColor;
  phdScienceStates: IColor;
  alexandria: IColor;
  geodes: IColor;
  indicator: IColor;
  warning: IColor;
  beige: IColorGradual;
  n: IColorGradual;
  white: string;
}
export const neutral = {
  base: '#f7f8f9',
  'dark-50': '#797F86',
  'dark-60': '#61656b',
  'dark-80': '#1f2226',
  'light-10': '#edeff2',
  'light-20': '#e8eaed',
  'light-30': '#f7f8f9',
  'light-40': '#b8bdc2',
  'light-50': '#61656b'
};
export const primary = {
  base: '#09212C',
  'dark-60': '#4a5d66',
  'dark-80': '#09212C',
  'light-20': '#e6e9eb',
  'light-30': '#c6cacc',
  'light-40': '#798f9a',
  'light-50': '#52666f'
};
export const secondary = {
  base: '#008abd',
  'dark-80': '#008abd',
  'dark-60': '#95A5AD',
  'light-20': '#e6f5fa'
};
export const gmBlue = {
  base: '#0F526F',
  'dark-80': '#0F526F',
  'dark-60': '#3D738A',
  'light-40': '#9FBAC5',
  'light-20': '#E6EDF0'
};
export const eurekaMath = {
  base: '#7ebb52',
  'dark-80': '#7ebb52',
  'light-20': '#c4e6ac'
};
export const eurekaMathBands = {
  base: '#1d7356',
  'dark-60': '#6ab336',
  'dark-80': '#1d7356',
  'light-20': '#e4e6eb',
  'light-30': '#bfd2e0',
  'light-40': '#dbe6da',
  'light-50': '#a6d99c'
};
export const eurekaMathStates = {
  base: '#186454',
  'dark-60': '#1c7360',
  'dark-80': '#186454',
  'light-20': '#e1e6e4',
  'light-40': '#a3bfb9',
  'light-50': '#247f62'
};
export const ww = {
  base: '#7CC7F1',
  'light-20': '#B3DDF4'
};
export const wwStates = {
  base: '#0F384D',
  'dark-60': '#465e6a',
  'dark-80': '#0F384D',
  'light-20': '#E6E9EB',
  'light-40': '#C6CACC',
  'light-50': '#54707d'
};
export const wwBands = {
  base: '#1d7356',
  'dark-60': '#176999',
  'dark-80': '#1d7356',
  'light-20': '#467fa4',
  'light-30': '#5997c0',
  'light-40': '#2897E0',
  'light-50': '#1D84BF'
};
export const phdScience = {
  base: '#835AA2',
  'light-30': '#C0A0D9'
};
export const phdScienceStates = {
  base: '#303C94',
  'dark-60': '#4250B8',
  'dark-80': '#303C94',
  'light-20': '#D3D6EB',
  'light-40': '#AEB5E6',
  'light-50': '#5B68C7'
};
export const alexandria = {
  base: '#ff8c00',
  'dark-80': '#ff8c00',
  'light-40': '#ffab42'
};
export const geodes = {
  base: '#1ca6df',
  'dark-80': '#1ca6df',
  'light-30': '#99d8f2'
};
export const correct = {
  base: '#21a621',
  'dark-80': '#21a621',
  'light-20': '#c3e6c3'
};
export const incorrect = {
  base: '#d42a2a',
  'dark-80': '#d42a2a',
  'light-20': '#f0cccc'
};
export const warning = {
  base: '#f2b230',
  'dark-80': '#f2b230',
  'light-20': '#ffeecc'
};
export const indicator = {
  base: '#ff4a1f',
  'dark-80': '#ff5b34',
  'light-20': '#f0cccc',
  'light-40': '#fd8366'
};
export const eurekaMathLap = {
  base: '#c4e6ac',
  'light-30': '#c4e6ac',
  'light-20': '#DBEECD'
};
export const wwLap = {
  base: '#b3ddf4',
  'light-30': '#b3ddf4',
  'light-20': '#D1EBFA'
};
export const phdLap = {
  base: '#c0a0d9',
  'light-30': '#C0A0D9',
  'light-20': '#E7DBF0'
};
export const transparent = {
  black: 'rgba(0, 0, 0, 16%)'
};
export const beige = {
  20: '#FAFBF9',
  40: '#F6F7F3',
  60: '#F2F4ED',
  100: '#EAEDE1',
  120: '#D6D7CB',
  140: '#C4C2AA',
  180: '#7A7562'
};
export const n = {
  '04': '#F5F5F5',
  10: '#E6E6E6',
  20: '#CCCCCC',
  40: '#999999',
  60: '#666666',
  100: '#000000'
};
export const pr = {
  10: '#E9F7FB',
  20: '#DAF3F6',
  40: '#BFE6EB',
  60: '#ABD5D8',
  80: '#A0C5C2',
  100: '#96B5AD' /* previous primary.100 color */,
  120: '#7CA3A1' /* previous primary.120 color */,
  140: '#649295' /* previous primary.140 color */,
  base: '#407177' /* previous primary.base.0 color */,
  170: '#355F64' /* previous primary.170 color */,
  180: '#2C4E53' /* previous primary.180 color */
};
export const resourceViewer = {
  white: '#FFF',
  primary,
  neutral
};
export const colors = {
  alexandria,
  black: '#000',
  correct,
  eurekaMath,
  eurekaMathBands,
  eurekaMathStates,
  geodes,
  gmBlue,
  incorrect,
  indicator,
  neutral,
  phdScience,
  phdScienceStates,
  primary,
  secondary,
  transparent,
  warning,
  white: '#FFF',
  ww,
  wwBands,
  wwStates,
  n,
  beige,
  pr,
  status: {
    error: ["100"]
  },
  resourceViewer
};